import { p4, p3 } from '@repo/ui/components/Typography';
import { hideScrollBar } from '@repo/ui/components/utilities';
import { QUERIES } from '@repo/ui/queries';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

import { ScrollButtonBase } from 'components/utilities/styles';
import { FlexColumn, FlexRow } from 'styles/layouts';

export const CardWrapper = styled(FlexColumn)<{
  isActive: boolean;
}>`
  align-items: center;

  gap: 6px;
  padding: 6px;

  border: 1px solid
    ${({ isActive }) => (isActive ? themeStyle.varBlueMedium : 'transparent')};

  html[data-theme='dark'] &&,
  .dark && {
    &:not(:hover) {
      border-color: ${({ isActive }) =>
        isActive ? themeStyle.varBlueMedium : themeStyle.varInkSuperLight};
    }
  }

  border-radius: ${themeStyle.radiusMedium};
  box-shadow:
    0 0 0 1px
      ${({ isActive }) => (isActive ? themeStyle.varBlueMedium : 'transparent')},
    ${themeStyle.shadowSoft};

  transition:
    0.3s border-color,
    0.3s box-shadow;

  cursor: pointer;

  &:hover {
    border-color: ${({ isActive }) =>
      isActive ? themeStyle.varBlueMedium : themeStyle.varInkLight};
  }

  html[data-theme='dark'] &&,
  .dark && {
    &:hover {
      box-shadow:
        0 0 0 1px
          ${({ isActive }) =>
            isActive ? themeStyle.varBlueMedium : themeStyle.varInkLight},
        ${themeStyle.shadowSoft};
    }
  }

  ${QUERIES.largeTabletAndUp} {
    gap: 10px;
    padding: 10px;

    border-radius: ${themeStyle.radiusLarge};
  }
`;

export const CardImage = styled.img`
  width: 84px;

  aspect-ratio: 1 / 1;

  border-radius: ${themeStyle.radiusSmall};

  ${QUERIES.largeTabletAndUp} {
    width: 152px;
  }
`;

export const CardLabel = styled.p`
  ${p4};

  ${QUERIES.largeTabletAndUp} {
    ${p3};
  }
`;

export const RowWrapper = styled(FlexRow)`
  position: relative;

  gap: 12px;
  overflow-x: scroll;

  padding-top: 50px;
  padding-bottom: 50px;
  margin: -50px -16px;

  ${hideScrollBar};

  ${QUERIES.largeTabletAndUp} {
    gap: 16px;

    margin-left: -24px;
    margin-right: -24px;
  }
`;

export const OuterRowWrapper = styled.div`
  position: relative;
  max-width: 100%;
`;

export const ScrollButton = styled(ScrollButtonBase)<{
  align: 'left' | 'right';
}>`
  visibility: hidden;

  ${({ align }) => align}: 15px;

  ${QUERIES.largeTabletAndUp} {
    visibility: visible;
  }
`;
